// extracted by mini-css-extract-plugin
export default {"label":"Label_label__Zz0X1","leftText":"Label_leftText__WaeVt","rightText":"Label_rightText__aJgby"};